module.exports = __webpack_public_path__ + "img/legisla-municipios.bd2a3786.png";